import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateInstagramIntegrationMutation = createMutationHook(
  ShopRendererApiClient.createInstagramIntegrationV2,
  {
    mutationKey: ['createInstagramIntegration'],
  },
)
